<template>
    <div>
        <div class="top_banner">
            <div class="top_banner_text">
                <p>电子商务</p>
                <!--<p>News</p>-->
            </div>
        </div>
        <div class="about_us_bg">
            <div class="w_1200 w_1200_boot non_margin">
                <div class="about_us">
                    <div class="about_tap clearfix">
                        <a href="" class="on">电子政务</a>
                        <a href="">电子商务</a>
                        <a href="">保险信贷</a>
                        <a href="">旅游行业</a>
                        <a href="">房屋租赁</a>
                    </div>
                    <!--解决方案-->
                    <div class="solution_box">
                        <h6 class="solution_title">行业痛点</h6>
                        <p class="solution_intro">

                        </p>
                        <div class="solution_pain clearfix">
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/qianshuxiaolvdi.png" alt="">
                                </div>
                                <p class="solution_block_text1">签署效率低</p>
                                <p class="solution_block_text2">多方签署费时费力，影响交易效率</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/kuaidishijianchang.png" alt="">
                                </div>
                                <p class="solution_block_text1">快递时间长</p>
                                <p class="solution_block_text2">传统打印、签署、快递方式周期长</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/anquanyinhuangao.png" alt="">
                                </div>
                                <p class="solution_block_text1">安全隐患高</p>
                                <p class="solution_block_text2">传统合同存在伪造抵赖等安全风险</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/hetongguanlinan.png" alt="">
                                </div>
                                <p class="solution_block_text1">合同管理难</p>
                                <p class="solution_block_text2">合同种类多难控制，数量多难管理</p>
                            </div>
                        </div>
                        <div class="solution_blank_height"></div>
                        <h6 class="solution_title">解决方案</h6>
                        <p class="solution_intro">

                        </p>
                        <div class="solution_pain solution_pain_govern2 clearfix">
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/xianshangqianshu.png" alt="">
                                </div>
                                <p class="solution_block_text1">在线签署</p>
                                <p class="solution_block_text2">缩短企业入驻及交易周期</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/dujuecuangai.png" alt="">
                                </div>
                                <p class="solution_block_text1">杜绝篡改</p>
                                <p class="solution_block_text2">签署不可抵赖，规避交易风险</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/dianzicunchu.png" alt="">
                                </div>
                                <p class="solution_block_text1">电子存储</p>
                                <p class="solution_block_text2">解放人力物力，降低运营成本</p>
                            </div>
                        </div>
                        <div class="solution_blank_height"></div>
                        <h6 class="solution_title">使用场景</h6>
                        <p class="solution_intro solution_intro_diff">

                        </p>
                        <div class="solution_chat">
                            <div class="solution_chat_block clearfix">
                                <div class="chat_block_left">
                                    <img src="@/assets/img/programme/icon_government.png" alt="">
                                    <p>电商平台</p>
                                </div>
                                <div class="chat_block_right">
                                    电商平台可通过大众签章与入驻企业签订入驻协议
                                </div>
                            </div>
                            <div class="solution_chat_block solution_chat_block_diff clearfix">
                                <div class="chat_block_left">
                                    <img src="@/assets/img/programme/icon_person.png" alt="">
                                    <p>入驻企业</p>
                                </div>
                                <div class="chat_block_right">
                                    入驻企业之间发生上下游交易，可使用大众签章签订大宗交易合同，并进行后续合同、签章管理
                                </div>
                            </div>
                            <div class="solution_chat_block solution_chat_block_diff2 clearfix">
                                <div class="chat_block_left">
                                    <img src="@/assets/img/programme/icon_enterprise.png" alt="">
                                    <p>平台用户</p>
                                </div>
                                <div class="chat_block_right">
                                    平台用户购买商品时可通过大众签章签署购买合同
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "indusSolutionAffair"
    }
</script>

<style scoped>
    .top_banner{
        background-image: url(~@/assets/img/banner/head_bar_solution.png);
        background-size: 100% 100%;

    }
</style>